import { Col, Row } from "react-bootstrap";
import { disclaimerResources } from "../Tos/Disclaimer";

export default function Resources() {
  const resources: {
    logo?: string;
    category: string;
    name: string;
    contactPhone?: string;
    contactEmail?: string;
    url?: string;
    description?: JSX.Element;
  }[] = [
    {
      category: "Title Company",
      logo: "liberty-land.png",
      name: "Liberty Land Abstract",
      contactPhone: "718.281.0505",
      contactEmail: "info@llabstract.com",
      url: "https://www.llabstract.com",
      description: (
        <>
          The largest privately owned title company in Queens, Bronx, Brooklyn,
          Staten Island, and Long Island.
        </>
      ),
    },
    {
      category: "Inpection Company",
      logo: "inspection-boys.png",
      name: "The Inpsection Boys",
      contactPhone: "516.591.3806",
      contactEmail: "nassau@theinspectionboys.com",
      url: "https://homeinspectionsli.com/",
      description: (
        <>
          Inspection company servicing all of NYC,Westchester, and Long Island.
          Mention code <b>LibertyConnect2025</b> for exclusive $75 discount.
        </>
      ),
    },
    {
      category: "Core CE Classes",
      logo: "main-st-success.png",
      name: "Main St. Success",
      contactPhone: "631.212.8328",
      contactEmail: "admin@mainstsuccess.com",
      url: "http://mainstsuccess.com",
      description: <>Real Estate School offering core CE credit bundle.</>,
    },
    {
      category: "Tax Deferred Exchanges",
      logo: "ipx-1031.png",
      name: "Investment Property Exchange Services, Inc. - IPX 1031",
      contactPhone: "877.230.1031",
      contactEmail: "marie.flavin@ipx1031.com",
      url: "https://www.ipx1031.com/",
      description: <>1031 Exchange Company for Northeast region.</>,
    },
    {
      category: "Real-Estate Attorneys",
      name: "Real-Estate Attorneys",
      contactEmail: "info@libertyconnect.nyc",
      description: (
        <>
          Please contact us to be connected to a real-estate attorney in your
          area.
        </>
      ),
    },
    {
      category: "Additional",
      name: "Additional Resources",
      description: <>Coming Soon</>,
    },
  ];
  return (
    <div className="resources">
      <Row className="justify-content-center">
        {resources.map((resource, i) => (
          <Col key={i} xl={4} sm={6}>
            <div className="resource-item">
              {resource.url ? (
                <a href={resource.url} target="_blank" rel="noreferrer">
                  {resource.logo ? (
                    <img
                      src={`/partnerLogos/${resource.logo}`}
                      alt={resource.name}
                    />
                  ) : (
                    <h3>{resource.name}</h3>
                  )}
                </a>
              ) : (
                <>
                  {resource.logo ? (
                    <img
                      src={`/partnerLogos/${resource.logo}`}
                      alt={resource.name}
                    />
                  ) : (
                    <h3>{resource.name}</h3>
                  )}
                </>
              )}
              <div>
                {resource.contactEmail && (
                  <div>
                    <a href={`mailto:${resource.contactEmail}`}>
                      {resource.contactEmail}
                    </a>
                  </div>
                )}
                {resource.contactPhone && <div>{resource.contactPhone}</div>}
              </div>
              {resource.description && <div>{resource.description}</div>}
            </div>
          </Col>
        ))}
      </Row>
      <p className="disclaimer">{disclaimerResources}</p>
    </div>
  );
}
